import { compareAsc, compareDesc } from 'date-fns';

export const dateProgress = (start: Date, end: Date) => {
  const now = new Date();
  const total = end.getTime() - start.getTime();
  const spent = Math.min(total, Math.max(0, now.getTime() - start.getTime()));
  return (spent / total) * 100;
};

// Apollo hands back the raw network result when its cache read-back is
// incomplete, so a date scalar typed `Date` can still be an ISO string.
export const latestDate = (dates: Nullable<Date | string>[]): Date | null => {
  const times = dates.flatMap(date => (date ? [new Date(date).getTime()] : []));
  return times.length ? new Date(Math.max(...times)) : null;
};

export function sortByDate<T>(
  array: T[],
  getDate: (entry: T) => Date,
  direction?: 'asc' | 'desc'
) {
  const sortFunc = direction === 'desc' ? compareDesc : compareAsc;

  array.sort((a, b) => sortFunc(getDate(a), getDate(b)));

  return array;
}
